var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceTagging(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8084 3.5625H26.2838C25.9255 3.56224 25.5817 3.7038 25.3275 3.95625L2.28751 26.9906C1.78314 27.4975 1.5 28.1834 1.5 28.8984C1.5 29.6135 1.78314 30.2994 2.28751 30.8063L13.2563 41.775C13.7633 42.2794 14.4494 42.5626 15.1645 42.5626C15.8797 42.5626 16.5658 42.2794 17.0728 41.775L40.1063 18.75C40.3587 18.4958 40.5003 18.152 40.5 17.7938V6.2625C40.5017 5.90816 40.4334 5.55698 40.2988 5.22917C40.1643 4.90136 39.9662 4.6034 39.716 4.35244C39.4659 4.10149 39.1685 3.9025 38.8411 3.76693C38.5138 3.63136 38.1628 3.56188 37.8084 3.5625Z",
    stroke: "#ABE138",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14.0625C32.4067 14.0625 31.8266 13.8866 31.3333 13.5569C30.8399 13.2273 30.4554 12.7587 30.2284 12.2106C30.0013 11.6624 29.9419 11.0592 30.0576 10.4772C30.1734 9.89529 30.4591 9.36074 30.8787 8.94118C31.2982 8.52162 31.8328 8.2359 32.4147 8.12015C32.9967 8.00439 33.5999 8.0638 34.1481 8.29086C34.6962 8.51793 35.1648 8.90244 35.4944 9.39579C35.8241 9.88914 36 10.4692 36 11.0625C36 11.8582 35.6839 12.6212 35.1213 13.1838C34.5587 13.7464 33.7957 14.0625 33 14.0625Z",
    fill: "#ABE138"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5625 45.5625L46.125 21C46.2471 20.8768 46.3432 20.7304 46.4077 20.5693C46.4721 20.4083 46.5035 20.2359 46.5 20.0625V8.0625",
    stroke: "#ABE138",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTagging);
export default __webpack_public_path__ + "static/media/price-tagging.a5b31064f30887dfb0be4b0ddf225e03.svg";
export { ForwardRef as ReactComponent };